import { render, staticRenderFns } from "./fabric.vue?vue&type=template&id=67ef8f39&scoped=true"
import script from "./fabric.vue?vue&type=script&lang=js"
export * from "./fabric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef8f39",
  null
  
)

export default component.exports